export default __webpack_public_path__ + "static/messages-cover-5ec0efdb0fea75c1aec276df5970ed28.jpeg";